export default __webpack_public_path__ + "static/media/ROBOPAC.5a6bc17b.png";